import { VaultDisplayInfo } from 'utils/vaultDisplayInfo'

export enum SortBy {
  Vault = 'vault',
  TvlUsd = 'tvlUsd',
  Apy = 'apy',
  DepositedUsd = 'depositedUsd',
  EarnedUsd = 'earnedUsd',
}

export enum Direction {
  Ascending = 'ascending',
  Descending = 'descending',
}

export interface VaultListRow extends VaultDisplayInfo {
  [SortBy.Apy]?: number
  [SortBy.TvlUsd]?: number
  [SortBy.DepositedUsd]?: number
  [SortBy.EarnedUsd]?: number
}

export interface VaultNumberUpdate {
  vaultId: string
  apy: number
  tvlUsd?: number
  depositedUsd?: number
  earnedUsd?: number
}

export interface SortConfig {
  key: SortBy | null
  direction: Direction | null
}
